import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class UsageTimerService {
  private startTime!: number;
  private maxUsageTimeInMinutes: number = 1; // Set the maximum usage time in minutes
  authService = inject(AuthenticationService);
  datePipe = inject(DatePipe);

  constructor (private http: HttpClient) {}

  setTimeout(timeout: number) {
    this.maxUsageTimeInMinutes = timeout;
  }

  startTimer() {
    this.startTime = new Date().getTime();
  }

  getUsageTimeInMinutes(): number {
    const currentTime = new Date().getTime();

    const elapsedTimeInMinutes = (currentTime - this.startTime) / 60000; // convert milliseconds to minutes
    return elapsedTimeInMinutes;
  }

  isTimeLimitExceeded(): boolean {
    return this.getUsageTimeInMinutes() > this.maxUsageTimeInMinutes;
  }

  updateTimer(): Observable<object> {
    const token = this.authService.getUserToken();
    const timer:any = {
      StartTime: this.datePipe.transform(this.startTime, 'yyyy-MM-ddTHH:mm:ss.SSS'),
      ActualTime: this.datePipe.transform(new Date().getTime(), 'yyyy-MM-ddTHH:mm:ss.SSS')
    };

    let options = { headers: new HttpHeaders( {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${token}`}) };

    return this.http.post( environment.API_URL + '/api/user/addLoggedTime', timer, options);
  }
}